const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Résout l'URL d'une image d'article.
 * - "" ou undefined → null
 * - "/api/..." → préfixée par REACT_APP_BACKEND_URL
 * - URL absolue → renvoyée telle quelle
 */
export function resolveArticleImage(url) {
  if (!url) return null;
  const trimmed = String(url).trim();
  if (!trimmed) return null;
  if (trimmed.startsWith('/api')) return `${API_URL}${trimmed}`;
  return trimmed;
}
